import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';
import { Asset, type Game, type Player } from '@ame/shared';

/** Per asset of de speler deze ronde al gegooid heeft (de dobbelsteen in het origineel). */
export type Gerold = Record<Asset, boolean>;

/** Begin van een ronde: nog niets gegooid. */
export const NIETS_GEROLD = Object.fromEntries(
  Object.values(Asset).map((asset) => [asset, false]),
) as Gerold;

/**
 * Wat `Layout` aan de spelschermen geeft, zoals `PlayerContext` in `Layout.tsx` van het
 * origineel: het spel, de ingelogde speler (uit `:userId`) en `rolledState`, dat bij elke
 * nieuwe ronde terug naar allemaal `false` gaat.
 */
export type PlayerContextWaarde = {
  game: Game;
  player: Player;
  rolledState: [Gerold, Dispatch<SetStateAction<Gerold>>];
};

export const PlayerContext = createContext<PlayerContextWaarde | undefined>(undefined);

/**
 * `useContext(PlayerContext)` uit het origineel, maar zonder `undefined`: binnen de
 * spelroutes (`/:gameId/:userId/...`) rendert `Layout` de schermen pas als spel en speler
 * er zijn.
 */
export function usePlayerContext(): PlayerContextWaarde {
  const waarde = useContext(PlayerContext);
  if (!waarde) throw new Error('usePlayerContext werkt alleen binnen de spelroutes (Layout).');
  return waarde;
}
